import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=49f29214"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49f29214')) {
      api.createRecord('49f29214', component.options)
    } else {
      api.reload('49f29214', component.options)
    }
    module.hot.accept("./UserProfile.vue?vue&type=template&id=49f29214", function () {
      api.rerender('49f29214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/UserProfile.vue"
export default component.exports